import React, { useState, useRef } from "react";
import {
  Grid,
  Button,
  Avatar, 
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@material-ui/core";
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/Delete';

import { useUserContext, firebaseUpload } from "../../../../context/UserContext";

import { firestore, storage, arrayUnion } from '../../../../firebase';

// styles
import useStyles from "./styles";

// components
import Widget from "../../../../components/Widget";
import PageTitle from "../../../../components/PageTitle";
import { Typography } from "../../../../components/Wrappers";
import Survey from "./components/Survey";

export default function NonAdminDashboard(props) {
  var classes = useStyles();
  var profile = useUserContext().userInformation;
  var userFiles = useUserContext().files;
  var userFilesUpdate= useUserContext().setFiles;
  const inputFile = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleDialogOpen = () => {
    setDialogOpen(true);
  }

  const handleDialogClose = () => {
    setDialogOpen(false);
  }

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    if(file) firebaseUpload(file);
    userFilesUpdate([...userFiles, file.name]);
    console.log(userFiles);
  };

  const firebaseDeleteFile = (fileName) => {
    let fileRef = storage.ref().child(localStorage.getItem('user_uid') + '/' + fileName);
    fileRef
        .delete()
        .then(() => {
        // console.log('file deleted from storage');
        firestore
            .collection('Users')
            .doc(localStorage.getItem('user_uid'))
            .update({
            fileSystem: arrayUnion.FieldValue.arrayRemove(fileName)
            })
            .then(() => {
            var newFileData = userFiles.filter((item) => item !== fileName)
            userFilesUpdate(newFileData);
            handleDialogClose();
            })
        })
    }

  return(
    <>
        <Dialog
        open={dialogOpen}
        onClose={() => {
          handleDialogClose();
          setSelectedFile(null);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{"Are you sure you would like to delete this file?"}</DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                You are about to delete "{selectedFile}". If you would like to go through with this action press "Delete" or else press "cancel".
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={() => {
                handleDialogClose();
                setSelectedFile(null);
                }} color="primary">
                Cancel
            </Button>
            <Button onClick={() => firebaseDeleteFile(selectedFile)} color="primary" autoFocus>
                Delete
            </Button>
            </DialogActions>
        </Dialog>
        <div className={classes.headerContainer}>
            <div>
            {profile.avatar ?
            <Avatar src={'data:image/png;base64,' + profile?.avatar} className={classes.headerAvatar} />
            : <Avatar className={classes.headerAvatar} />}
            </div>
            <PageTitle title={profile.name ? profile?.name : null} />
        </div>
        <Grid container spacing={4}>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Widget
                    title="Profile"
                    upperTitle
                    className={classes.card}
                    bodyClass={classes.fullHeightBody}
                >
                    <div className={classes.performanceLegendWrapper}>
                        <div className={classes.legendElement}>
                            <Typography color="text" colorBrightness="secondary">
                                Name: {profile?.name}<br/>
                                Email: {profile?.email}<br/>
                                Completed Survey: {profile.surveyCompleted ? 'Yes' : 'No'}
                                {/* <Avatar src={'data:image/png;base64,' + profile?.avatar} className={classes.headerAvatar} /> */}
                            </Typography>
                        </div>
                    </div>
                </Widget>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
                <Widget
                    title="Scorecard"
                    upperTitle
                    className={classes.card}
                    bodyClass={classes.fullHeightBody}
                >
                    <div className={classes.performanceLegendWrapper}>
                        <div className={classes.legendElement}>
                            {profile?.dashboard ? (
                                <Typography color="text" colorBrightness="secondary">
                                    Real Estate Portfolio Grade: {profile?.dashboard?.portfolioGrade} <br/>
                                    Real Estate Portfolio Analysis for Earnings Generation: {profile?.dashboard?.generationGrade} <br />
                                    Operating Expense & Occupancy Cost Savings: {profile?.dashboard?.savingsGrade} <br/>
                                    Monetization of Excess Real Estate Assets: {profile?.dashboard?.assetsGrade} <br/>
                                    IT Tools for Earnings Measurment: {profile?.dashboard?.measurementGrade} <br/>
                                </Typography>
                            ) : (
                                <Typography color="text" colorBrightness="secondary">
                                    Real Estate Portfolio Grade: N/A <br/>
                                    Real Estate Portfolio Analysis for Earnings Generation: N/A <br />
                                    Operating Expense & Occupancy Cost Savings: N/A <br/>
                                    Monetization of Excess Real Estate Assets: N/A <br/>
                                    IT Tools for Earnings Measurment: N/A <br/>
                                </Typography>
                            )}
                        </div>
                    </div>
                </Widget>
            </Grid>
            <Grid item xs={12}>
                {profile?.surveyCompleted ? (
                    <Widget
                        title="Corp. RE Earnings Diagnostic - Questionnaire Answers"
                        upperTitle
                        className={classes.card}
                        bodyClass={classes.fullHeightBody}
                    >
                        <div className={classes.performanceLegendWrapper}>
                            <div className={classes.legendElement}>
                                    <Typography color="text" colorBrightness="secondary" wrap >
                                        Email Address <br/> Answer: {profile?.survey?.email} <br/><br/>
                                        Name/Contact <br/> Answer: {profile?.survey?.name} <br/><br/>
                                        Company <br/> Answer: {profile?.survey?.company} <br/><br/>
                                        Sector/Industry <br/> Answer: {profile?.survey?.industry} <br/><br/>
                                        Phone <br/> Answer: {profile?.survey?.phone} <br/><br/>
                                        The corporate RE function has a clearly defined mission of contributing earnings to the enterprise? <br/> Answer: {profile?.survey?.mission} <br/><br/>
                                        There is untapped potential in the Company's RE assets for cost savings and new earnings. <br/> Answer: {profile?.survey.potential} <br/><br/>
                                        The Company is operating at a "best practices" level with respect to cost reduction strategies for real estate operating expenses and space utilization. <br/> Answer: {profile?.survey?.bestPractices} <br/><br/>
                                        The Company has established Key Performance Indicator's ("KPI's") for measuring RE's contribution to the success of the enterprise. <br/> Answer: {profile?.survey?.kpi} <br/><br/>
                                        The Company has a proactive strategy for disposition of excess property and leased space. <br/> Answer: {profile?.survey?.disposition} <br/><br/>
                                        The Company is aggressively executing the disposition process. <br/> Answer: {profile?.survey?.aggressive} <br/><br/>
                                        The company uses NRV (net realizable value) models that assist in space strategy and financial decision making <br/> Answer: {profile?.survey?.nrv} <br/><br/>
                                        Does the Company's RE portfolio tie into the ERP system? <br/> Answer: {profile?.survey?.erpSystem} <br/><br/>
                                        The Company has the ability to breakout financials for RE occupancy costs. <br/> Answer: {profile?.survey?.breakoutFinancials} <br/><br/>
                                        If the Company runs SAP or Oracle - Is the RE module currently activated? <br/> Answer: {profile?.survey?.REModule} <br/><br/>
                                        What are the barriers to optimizing real estate assets in your enterprise? <br/> Answer: {profile?.survey?.challenges} <br/><br/>
                                    </Typography>
                            </div>
                        </div>
                    </Widget>
                ) : (
                    <Survey/>
                )}
            </Grid>
            <Grid item xs={12}>
                <input
                    style={{ display: "none" }}
                    type="file"
                    ref={inputFile}
                    onChange={handleFileInput}
                />
                    <Widget
                        title="Files"
                        upperTitle
                        className={classes.card}
                        bodyClass={classes.fullHeightBody}
                        menuItems={true}
                        menuUpload={true}
                        menuUploadName={'Upload'}
                        editUploadClick={() => inputFile.current.click()}
                    >
                        {userFiles?.length > 0 ? (
                            <>
                            {userFiles.map((file) => {
                                return(
                                <ListItem 
                                    button 
                                    divider={true} 
                                    ContainerComponent="div" 
                                    className={classes.listItem} 
                                    onClick={() => {
                                        console.log(file);
                                        localStorage.setItem('file', file);
                                        props.history.push(`/app/${localStorage.getItem('user_uid')}/${file}`)
                                    }}
                                >
                                    <ListItemAvatar>
                                    <Avatar>
                                        <FolderIcon />
                                    </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                    primary={file}
                                    />
                                    <ListItemSecondaryAction>
                                    <IconButton edge="end" aria-label="delete" onClick={() => {
                                        handleDialogOpen();
                                        setSelectedFile(file);
                                    }}>
                                        <DeleteIcon />
                                    </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                                )
                            })}
                            </>
                        ) : (
                            <Typography
                                color="text"
                                colorBrightness="secondary"
                            >
                                No files available 
                            </Typography>
                        )}
                    </Widget>
            </Grid>
        </Grid>
    </>
  );
}